import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/DraftOrder/DraftOrder.js
const DraftOrder = createSectionForm({
  icon: "file-list-line",
  title: "Draft Order",
  fields: [
    { name: "title", label: "Title", placeholder: "Review Your Order" },
    { name: "description", label: "Description", type: "textarea" },
  ],
});

export default DraftOrder;
